// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7558) return "static/chunks/7558-62e825142ec2191d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1936":"0d8e709d","3332":"0b09f172"}[chunkId] || chunkId) + "." + {"735":"39c5c0e7aa7b9f3a","853":"ef780dc68a21a138","1027":"4b1a80e70c4cd17c","1936":"b7a760751368b561","3332":"a89dce2590f01183","6050":"816b966a3784fb5e","6952":"a2e72a47561b2a36","8969":"e4f55ffb35e94abb"}[chunkId] + ".js";
};